/**
 * @fileoverview gRPC-Web generated client stub for io.codedrills.proto.user
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js')

var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js')

var io_codedrills_proto_user_candidate_pb = require('../../../../io/codedrills/proto/user/candidate_pb.js')

var io_codedrills_proto_user_file_pb = require('../../../../io/codedrills/proto/user/file_pb.js')
const proto = {};
proto.io = {};
proto.io.codedrills = {};
proto.io.codedrills.proto = {};
proto.io.codedrills.proto.user = require('./candidate_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.user.CandidateServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.StartTestRequest,
 *   !proto.io.codedrills.proto.user.StartTestResponse>}
 */
const methodInfo_CandidateService_StartTest = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.StartTestResponse,
  /** @param {!proto.io.codedrills.proto.user.StartTestRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.StartTestResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.StartTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.StartTestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.StartTestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.startTest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/StartTest',
      request,
      metadata || {},
      methodInfo_CandidateService_StartTest,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.StartTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.StartTestResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.startTest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/StartTest',
      request,
      metadata || {},
      methodInfo_CandidateService_StartTest);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.EndTestRequest,
 *   !proto.io.codedrills.proto.user.EndTestResponse>}
 */
const methodInfo_CandidateService_EndTest = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.EndTestResponse,
  /** @param {!proto.io.codedrills.proto.user.EndTestRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.EndTestResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.EndTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.EndTestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.EndTestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.endTest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/EndTest',
      request,
      metadata || {},
      methodInfo_CandidateService_EndTest,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.EndTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.EndTestResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.endTest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/EndTest',
      request,
      metadata || {},
      methodInfo_CandidateService_EndTest);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.SubmitAnswerRequest,
 *   !proto.io.codedrills.proto.user.SubmitAnswerResponse>}
 */
const methodInfo_CandidateService_SubmitAnswer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.SubmitAnswerResponse,
  /** @param {!proto.io.codedrills.proto.user.SubmitAnswerRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.SubmitAnswerResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.SubmitAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.SubmitAnswerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.SubmitAnswerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.submitAnswer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/SubmitAnswer',
      request,
      metadata || {},
      methodInfo_CandidateService_SubmitAnswer,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.SubmitAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.SubmitAnswerResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.submitAnswer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/SubmitAnswer',
      request,
      metadata || {},
      methodInfo_CandidateService_SubmitAnswer);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.CandidateFeedbackRequest,
 *   !proto.io.codedrills.proto.user.CandidateFeedbackResponse>}
 */
const methodInfo_CandidateService_CandidateFeedback = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.CandidateFeedbackResponse,
  /** @param {!proto.io.codedrills.proto.user.CandidateFeedbackRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.CandidateFeedbackResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.CandidateFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.CandidateFeedbackResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.CandidateFeedbackResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.candidateFeedback =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/CandidateFeedback',
      request,
      metadata || {},
      methodInfo_CandidateService_CandidateFeedback,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.CandidateFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.CandidateFeedbackResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.candidateFeedback =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/CandidateFeedback',
      request,
      metadata || {},
      methodInfo_CandidateService_CandidateFeedback);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetTestRequest,
 *   !proto.io.codedrills.proto.user.GetTestResponse>}
 */
const methodInfo_CandidateService_GetTest = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetTestResponse,
  /** @param {!proto.io.codedrills.proto.user.GetTestRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetTestResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetTestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetTestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.getTest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/GetTest',
      request,
      metadata || {},
      methodInfo_CandidateService_GetTest,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetTestResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.getTest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/GetTest',
      request,
      metadata || {},
      methodInfo_CandidateService_GetTest);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.LogProctoringEventRequest,
 *   !proto.io.codedrills.proto.user.LogProctoringEventResponse>}
 */
const methodInfo_CandidateService_LogProctoringEvent = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.LogProctoringEventResponse,
  /** @param {!proto.io.codedrills.proto.user.LogProctoringEventRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.LogProctoringEventResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.LogProctoringEventRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.LogProctoringEventResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.LogProctoringEventResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.logProctoringEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/LogProctoringEvent',
      request,
      metadata || {},
      methodInfo_CandidateService_LogProctoringEvent,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.LogProctoringEventRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.LogProctoringEventResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.logProctoringEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/LogProctoringEvent',
      request,
      metadata || {},
      methodInfo_CandidateService_LogProctoringEvent);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.SaveJobRequest,
 *   !proto.io.codedrills.proto.user.SaveJobResponse>}
 */
const methodInfo_CandidateService_SaveJob = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.SaveJobResponse,
  /** @param {!proto.io.codedrills.proto.user.SaveJobRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.SaveJobResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.SaveJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.SaveJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.SaveJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.saveJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/SaveJob',
      request,
      metadata || {},
      methodInfo_CandidateService_SaveJob,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.SaveJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.SaveJobResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.saveJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/SaveJob',
      request,
      metadata || {},
      methodInfo_CandidateService_SaveJob);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.CheckJobAppliedStatusRequest,
 *   !proto.io.codedrills.proto.user.CheckJobAppliedStatusResponse>}
 */
const methodInfo_CandidateService_CheckJobAppliedStatus = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.CheckJobAppliedStatusResponse,
  /** @param {!proto.io.codedrills.proto.user.CheckJobAppliedStatusRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.CheckJobAppliedStatusResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.CheckJobAppliedStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.CheckJobAppliedStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.CheckJobAppliedStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.checkJobAppliedStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/CheckJobAppliedStatus',
      request,
      metadata || {},
      methodInfo_CandidateService_CheckJobAppliedStatus,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.CheckJobAppliedStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.CheckJobAppliedStatusResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.checkJobAppliedStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/CheckJobAppliedStatus',
      request,
      metadata || {},
      methodInfo_CandidateService_CheckJobAppliedStatus);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetSavedJobsRequest,
 *   !proto.io.codedrills.proto.user.GetSavedJobsResponse>}
 */
const methodInfo_CandidateService_GetSavedJobs = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetSavedJobsResponse,
  /** @param {!proto.io.codedrills.proto.user.GetSavedJobsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetSavedJobsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetSavedJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetSavedJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetSavedJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.getSavedJobs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/GetSavedJobs',
      request,
      metadata || {},
      methodInfo_CandidateService_GetSavedJobs,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetSavedJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetSavedJobsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.getSavedJobs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/GetSavedJobs',
      request,
      metadata || {},
      methodInfo_CandidateService_GetSavedJobs);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.ListJobsRequest,
 *   !proto.io.codedrills.proto.user.ListJobsResponse>}
 */
const methodInfo_CandidateService_ListJobs = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.ListJobsResponse,
  /** @param {!proto.io.codedrills.proto.user.ListJobsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.ListJobsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.ListJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.ListJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.ListJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.listJobs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/ListJobs',
      request,
      metadata || {},
      methodInfo_CandidateService_ListJobs,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.ListJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.ListJobsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.listJobs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/ListJobs',
      request,
      metadata || {},
      methodInfo_CandidateService_ListJobs);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.ApplyJobRequest,
 *   !proto.io.codedrills.proto.user.ApplyJobResponse>}
 */
const methodInfo_CandidateService_ApplyJob = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.ApplyJobResponse,
  /** @param {!proto.io.codedrills.proto.user.ApplyJobRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.ApplyJobResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.ApplyJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.ApplyJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.ApplyJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.applyJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/ApplyJob',
      request,
      metadata || {},
      methodInfo_CandidateService_ApplyJob,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.ApplyJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.ApplyJobResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.applyJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/ApplyJob',
      request,
      metadata || {},
      methodInfo_CandidateService_ApplyJob);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateResumeRequest,
 *   !proto.io.codedrills.proto.user.UpdateResumeResponse>}
 */
const methodInfo_CandidateService_UpdateResume = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateResumeResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateResumeRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateResumeResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateResumeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateResumeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateResumeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.updateResume =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/UpdateResume',
      request,
      metadata || {},
      methodInfo_CandidateService_UpdateResume,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateResumeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateResumeResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.updateResume =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/UpdateResume',
      request,
      metadata || {},
      methodInfo_CandidateService_UpdateResume);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetResumeRequest,
 *   !proto.io.codedrills.proto.user.GetResumeResponse>}
 */
const methodInfo_CandidateService_GetResume = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetResumeResponse,
  /** @param {!proto.io.codedrills.proto.user.GetResumeRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetResumeResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetResumeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetResumeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetResumeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CandidateServiceClient.prototype.getResume =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/GetResume',
      request,
      metadata || {},
      methodInfo_CandidateService_GetResume,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetResumeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetResumeResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CandidateServicePromiseClient.prototype.getResume =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CandidateService/GetResume',
      request,
      metadata || {},
      methodInfo_CandidateService_GetResume);
};


module.exports = proto.io.codedrills.proto.user;

